import "datatables.net";
import "../components/hs-datatables";
import "flatpickr";
import "../components/hs-range-datepicker";
import "../components/hs-selectpicker";
import "../components/hs-chart-pie";
import "../components/hs-progress-bar";

export default {
  init() {
    const items = $.HSCore.components.HSChartPie.init(".js-pie");
  },
  finalize() {
    $(".download-user-received-survey-two").on("click", function () {
      var url = ajaxdta.ajaxurl + "?action=get_user_received_survey_two_data";

      $.ajax({
        type: "POST",
        url: url,
        success: function (res, status, xhr) {
          var csvData = new Blob([res], { type: "text/csv;charset=utf-8;" });
          var csvURL = window.URL.createObjectURL(csvData);
          var tempLink = document.createElement("a");
          tempLink.href = csvURL;
          tempLink.setAttribute("download", "user-received-survey-two.csv");
          tempLink.click();
        },
      });
    });

    $(".download-enrolment-course").on("click", function () {
      var enrolment_type = $(this).data("enrolment-type");
      var url = ajaxdta.ajaxurl + "?action=get_enrolment_data";

      $.ajax({
        type: "POST",
        url: url,
        data: {
          enrolment_type: enrolment_type,
        },
        success: function (res, status, xhr) {
          var csvData = new Blob([res], { type: "text/csv;charset=utf-8;" });
          var csvURL = window.URL.createObjectURL(csvData);
          var tempLink = document.createElement("a");
          tempLink.href = csvURL;
          tempLink.setAttribute(
            "download",
            `enrolment-data-${enrolment_type}.csv`
          );
          tempLink.click();
        },
      });
    });
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/dta-enrolments-insights.js